import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  IconExpense,
  IconPOS,
  IconProducts,
  IconReports,
  IconStock,
  IconUsers,
} from './NavIcons';

const items = [
  { to: '/products', label: 'Product Management', Icon: IconProducts },
  { to: '/stock', label: 'Stock Management', Icon: IconStock },
  { to: '/sale', label: 'Sale', Icon: IconPOS },
  { to: '/expenses', label: 'Expense', Icon: IconExpense },
  { to: '/reports', label: 'Reports', Icon: IconReports },
  { to: '/users', label: 'User Management', Icon: IconUsers },
];

export function Sidebar() {
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();

  function handleLogout() {
    logout();
    navigate('/', { replace: true });
  }

  return (
    <aside className="sidebar" aria-label="Main navigation">
      <div className="sidebar-brand">
        <div className="sidebar-brand-text">
          <span className="sidebar-logo">POS system</span>
          <span className="sidebar-tagline">Point of sale</span>
        </div>
      </div>
      <nav className="sidebar-nav">
        {items.map(({ to, label, Icon }) => (
          <NavLink
            key={to}
            to={to}
            title={label}
            className={({ isActive }) =>
              `sidebar-link${isActive ? ' sidebar-link--active' : ''}`
            }
            end={to === '/sale'}
          >
            <span className="sidebar-icon" aria-hidden>
              <Icon className="sidebar-svg" />
            </span>
            <span className="sidebar-label">{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="sidebar-footer">
        {currentUser && (
          <div className="sidebar-user">
            <span className="sidebar-user-name">{currentUser.name}</span>
            <span className="sidebar-user-role">{currentUser.role}</span>
          </div>
        )}
        <button
          type="button"
          className="sidebar-logout"
          onClick={handleLogout}
        >
          Sign out
        </button>
      </div>
    </aside>
  );
}
